// src/redux/userSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async thunk for fetching users
export const fetchHomeObject = createAsyncThunk(
  "users/fetchHomeObject",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get("https://cms.recdbase.org/api/request/home-page");
      return response.data; // Return the fetched data
    } catch (error) {
      return rejectWithValue(error.response?.data || "An error occurred");
    }
  }
);
export const fetchAboutObject = createAsyncThunk(
    "users/fetchAboutObject",
    async (_, { rejectWithValue }) => {
      try {
        const response = await axios.get("https://cms.recdbase.org/api/request/about-us");
        console.log(response.data);
        
        return response.data; // Return the fetched data
      } catch (error) {
        return rejectWithValue(error.response?.data || "An error occurred");
      }
    }
  );

  export const registerUser = createAsyncThunk(
    "auth/register",
    async (userData, { rejectWithValue }) => {
      try {
        const response = await axios.post("https://api.recdbase.org/auth/register", userData);
  
        // ✅ Store email in localStorage if registration is successful
        if (response.data && userData.email) {
          localStorage.setItem("userEmail", userData.email);
        }
  
        console.log(response.data);
        
        return response.data; // Assuming the API returns some user data
      } catch (error) {
        return rejectWithValue(
          error.response?.data?.message || "Registration failed"
        );
      }
    }
  );
  
  export const login = createAsyncThunk(
    "auth/login",
    async (userData, { rejectWithValue }) => {
      try {
        const response = await axios.post("https://api.recdbase.org/auth/login", userData);
        console.log(response.data);
        return response.data; // Assuming the API returns some user data
      } catch (error) {
        console.log(error?.response?.data);
        
        return rejectWithValue(
          error.response?.data?.message || "Login failed"
        );
      }
    }
  );

  

const homeSlice = createSlice({
  name: "home",
  initialState: {
    homeObject: [],
    aboutObject: [],
    successMessage: null,
    users: null,
    token: null,
    loginMessage: "",
    loading: false,
    signLoading: false,
    signUpLoading: false,
    error: null,
  },
  reducers: {
    clearToken: (state) => {
      state.token = null; // Reset message to close the popup
      state.users = null
    },
    clearError: (state) => {
      state.error = null; // Reset error state
    },
  }, // No reducers needed for async API calls
  extraReducers: (builder) => {
    builder
      .addCase(fetchHomeObject.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchHomeObject.fulfilled, (state, action) => {
        state.loading = false;
        state.homeObject = action.payload;
      })
      .addCase(fetchHomeObject.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

      builder
      .addCase(fetchAboutObject.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAboutObject.fulfilled, (state, action) => {
        state.loading = false;
        state.aboutObject = action.payload;
      })
      .addCase(fetchAboutObject.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

      builder
      .addCase(registerUser.pending, (state) => {
        state.signUpLoading = true;
        state.error = null;
      })
      .addCase(registerUser.fulfilled, (state, action) => {
        state.signUpLoading = false;
        state.successMessage = action.payload;
        state.users = action.payload;
        state.token = action.payload.token;
      })
      .addCase(registerUser.rejected, (state, action) => {
        state.signUpLoading = false;
        state.error = action.payload;
      });
      builder
      .addCase(login.pending, (state) => {
        state.signLoading = true;
        state.error = null;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.signLoading = false;
        state.users = action.payload;
        state.token = action.payload.token;
        state.loginMessage = action.payload.message
       
      })
      .addCase(login.rejected, (state, action) => {
        state.signLoading = false;
        state.error = action.payload;
        state.loginMessage = action.payload.message
      });
  },
});
export const { clearToken, clearError } = homeSlice.actions;

export default homeSlice.reducer;
